import { hasConditionsForQuestion } from '@nsr/react-query-builder-executor';
import { CONSTANTS } from './Configuration';
import partition from 'lodash/partition';
import { isQueryEmpty } from './QueryHelpers';

const hasDiscountsForQuestion = (it, questionId) => {
    const matches = it.where?.filter(where => where.attribute?.value?.id === questionId);
    return matches;
};

export const checkForAssociatedConditionalLogicThenRemove = (applicationPages, applicationSections, applicationQuestions, id, controlType) => {
    if (!applicationPages || !applicationSections || !applicationQuestions || !id || !controlType) {
        return [];
    }
    const filterForConditions = (it, questionId) => it.filter(item => hasConditionsForQuestion(item, questionId));
    const { appTemplateControlTypes,} = CONSTANTS;
    switch (controlType) {
        case appTemplateControlTypes.page: {
            const [questionsInThisPage, questionsNotInThisPage] = partition(applicationQuestions, it => it.pageId === id);
            const otherPages = applicationPages.filter(it => it.id !== id);
            const sectionsNotInThisPage = applicationSections.filter(it => it.pageId !== id);
            const result = questionsInThisPage.reduce((memo, question) => {
                const matches = {
                    question,
                    matchingPages: filterForConditions(otherPages, question.id),
                    matchingQuestions: filterForConditions(questionsNotInThisPage, question.id),
                    matchingSections: filterForConditions(sectionsNotInThisPage, question.id),
                };
                if (matches.matchingPages.length > 0 || matches.matchingQuestions.length > 0 || matches.matchingSections.length > 0) {
                    return memo.concat(matches);
                }
                return memo;
            }, []);
            return result;
        }
        case appTemplateControlTypes.section: {
            const [questionsInThisSection, questionsNotInThisSection] = partition(applicationQuestions, it => it.sectionId === id);
            const otherSections = applicationSections.filter(it => it.id !== id);
            const result = questionsInThisSection.reduce((memo, question) => {
                const matches = {
                    question,
                    matchingPages: filterForConditions(applicationPages, question.id),
                    matchingQuestions: filterForConditions(questionsNotInThisSection, question.id),
                    matchingSections: filterForConditions(otherSections, question.id),
                };
                if (matches.matchingPages.length > 0 || matches.matchingQuestions.length > 0 || matches.matchingSections.length > 0) {
                    return memo.concat(matches);
                }
                return memo;
            }, []);
            return result;
        }
        case appTemplateControlTypes.question: {
            const question = applicationQuestions.find(it => it.id === id);
            const otherQuestions = applicationQuestions.filter(it => it.id !== id);
            const matches = {
                question,
                matchingPages: filterForConditions(applicationPages, id),
                matchingQuestions: filterForConditions(otherQuestions, id),
                matchingSections: filterForConditions(applicationSections, id),
            };
            if (matches.matchingPages.length > 0 || matches.matchingQuestions.length > 0 || matches.matchingSections.length > 0) {
                return [matches];
            }
            else {
                return [];
            }
        }
        default:
            return [];
    }
};

export const checkForAssociatedDiscountCodes = (applicationSections, applicationQuestions, id, controlType, originalTemplateId, discountCodes) => {
    const discountCodesToCheck = discountCodes?.filter(code => code.applicationForms?.length > 0);
    if (!applicationSections || !applicationQuestions || !id || !controlType || !discountCodes?.length || !discountCodesToCheck.length) {
        return [];
    }
    const matches = [];
    for (let i = 0; i < discountCodesToCheck.length; i ++) {
        const applicationForms = discountCodesToCheck[i].applicationForms.filter(form => !isQueryEmpty(form.query) && form.id === originalTemplateId).map(form => form.query);
        if (applicationForms?.length > 0) {
            const { appTemplateControlTypes,} = CONSTANTS;
            switch (controlType) {
                case appTemplateControlTypes.page: {
                    const questionsInThisPage = applicationQuestions.filter(it => it.pageId === id);
                    for (let j = 0; j < applicationForms.length; j++) {
                        for (let k = 0; k < questionsInThisPage.length; k++) {
                            if(hasDiscountsForQuestion(applicationForms[j], questionsInThisPage[k].id).length > 0) {
                                matches.push(discountCodesToCheck[i].code);
                            }
                        }
                    }
                    break;
                }
                case appTemplateControlTypes.section: {
                    const questionsInThisSection = applicationQuestions.filter( it => it.sectionId === id);
                    for (let j = 0; j < applicationForms.length; j++) {
                        for (let k = 0; k < questionsInThisSection.length; k++) {
                            if(hasDiscountsForQuestion(applicationForms[j], questionsInThisSection[k].id).length > 0) {
                                matches.push(discountCodesToCheck[i].code);
                            }
                        }
                    }
                    break;
                }
                case appTemplateControlTypes.question: {
                    for (let j = 0; j < applicationForms.length; j++) {
                        if(hasDiscountsForQuestion(applicationForms[j], id).length > 0) {
                            matches.push(discountCodesToCheck[i].code);
                        }
                    }
                    break;
                }
                default:
                    break;
            }
        }
    }
    return matches;  
};